export const slugify = (str)=>str ? str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '') : '';
export const capitalizeFirstLetter = (input)=>input.trim().length > 0 ? input.charAt(0).toUpperCase() + input.slice(1) : input;
export const convertEmToPx = (em)=>parseFloat(getComputedStyle(document.documentElement).fontSize) * em;
export const noOp = (s)=>s;
